import { render, staticRenderFns } from "./QuotationBreadcrumbEdit.vue?vue&type=template&id=46a5a71f&scoped=true&lang=html&"
import script from "./QuotationBreadcrumbEdit.vue?vue&type=script&lang=js&"
export * from "./QuotationBreadcrumbEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuotationBreadcrumbEdit.vue?vue&type=style&index=0&id=46a5a71f&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5a71f",
  null
  
)

export default component.exports